import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'bmcore-login-page',
  templateUrl: './bmcore-login-page.component.html',
  styleUrls: ['./bmcore-login-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLoginPageComponent {}
